import { post } from "../../api/HttpClient.js";
import { BASE_URL, SearchBookings_url } from "../../config/ApiConfig.js";
import { AppConstant } from "../../config/AppConstants.js";

export const FindColleagues_api = (requestParams) => {
  requestParams.AppVersion = AppConstant.AppVersion;
  requestParams.Language = AppConstant.Language;
  requestParams.DeviceId = AppConstant.DeviceID;
  requestParams.OsVersion = AppConstant.OsVersion;
  requestParams.ManufactureModel = AppConstant.ManufactureModel;

  return post({
    url: `${BASE_URL}${SearchBookings_url}`,
    params: requestParams,
  });
};
